import {Component} from '@angular/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  urlServices = environment.urlService;


  constructor() {
    let count = localStorage.getItem("fingerCount");
    console.log("count", count);
    if(count == null){
      console.log("Se crea localStorage");
      localStorage.setItem("fingerCount","0")
    }
  }
}
